import React, { useState } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { HIDDEN, SHOW, FADE, HIDE } from '../../HOME/const';
import { delay } from '../../HOME/utils';
import { Background } from '../COMPONENTS/Background';
import Toolbar from '../COMPONENTS/Toolbar';
import Scoreboard from '../COMPONENTS/Scoreboard';
import Board from '../COMPONENTS/Board';
import Options from '../COMPONENTS/Options';
import Leaderboard from '../COMPONENTS/Leaderboard';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';

const GamePage = props => {
  const [options, setOptions] = useState(HIDDEN);

  const handleOptions = e => {
    props.requestResetStats(false);
    props.requestSurrender(false);

    if (options === SHOW) {
      hideOptions();
    } else if (options === HIDDEN) {
      setOptions(SHOW);
    }
  };

  const hideOptions = e => {
    if (options === SHOW) {
      setOptions(FADE);
      delay(() => setOptions(HIDDEN));
    }
  };

  const handleClick = e => {
    let id = e.target.id;

    if (!id) {
      id = e.target.parentElement.id;
    }

    if (id !== 'options-button' && !id.startsWith('volume-')) {
      hideOptions();
    }
  };

  return (
    <div className="page-root">
      <div className="nm-page ta-game-page" style={{ backgroundImage: Background }} onClick={handleClick}>
        <Scoreboard />
        <Board />
        {props.showLeaders === HIDE ? null : <Leaderboard />}
      </div>
      <Options op={options} hideOptions={hideOptions} />
      <Toolbar onClickOptions={handleOptions} hideOptions={hideOptions} />
      {props.showLeaders === HIDE ? (
        <>
          <BackButton />
          <HomeButton />
        </>
      ) : null}
    </div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender }
)(GamePage);
